import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/config";

export const useBilledVsCollectedChart = ({ dateRange } = {}) => {
  return useQuery({
    queryKey: ["billed-vs-collected-chart", dateRange],
    queryFn: async () => {
      const params = { order: "asc" };

      if (dateRange?.from && dateRange?.to) {
        params.start_date = dateRange.from;
        params.end_date = dateRange.to;
      }

      const data = await api.get("billed-vs-collected-chart", { params });
      return data.data.data;
    },
  });
};
